import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import useFetchExpenseBalance from 'src/Hooks/Queries/useFetchExpenseBalance';
import { formatEuros } from 'src/Utils/formatEuros';
import { formatNameList } from 'src/Utils/formatNameList';
import { formatSettlementTargetName } from 'src/Utils/formatSettlementTargetName';

import styles from './NetBalanceHeader.module.scss';

const NetBalanceHeader = () => {
  const { t } = useTranslation();
  const { data } = useFetchExpenseBalance();

  if (!data || data.myNetBalance === undefined) return null;

  const net = data.myNetBalance;
  const conjunction = t('expenses.netBalance.conjunction', 'et');
  const moreLabel = (count: number) =>
    t('expenses.netBalance.moreOthers', { count, defaultValue: '{{count}} autres' });

  if (net > 0) {
    const names = data.owedToMe.map(item => formatSettlementTargetName(item.from));
    return (
      <div className={styles.container}>
        <p className={classnames(styles.sentence, styles.positive)}>
          {t('expenses.youAreOwed', 'On vous doit')} {formatEuros(net)}
        </p>
        <p className={styles.subline}>
          {t('expenses.owedBy', 'Dû par')} {formatNameList(names, moreLabel, conjunction)}
        </p>
      </div>
    );
  }

  if (net < 0) {
    const names = data.iOwe.map(item => formatSettlementTargetName(item.to));
    return (
      <div className={styles.container}>
        <p className={classnames(styles.sentence, styles.negative)}>
          {t('expenses.youOwe', 'Vous devez')} {formatEuros(-net)}
        </p>
        <p className={styles.subline}>
          {t('expenses.owedTo', 'À')} {formatNameList(names, moreLabel, conjunction)}
        </p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <p className={classnames(styles.sentence, styles.neutral)}>
        {t('expenses.youAreBalanced', 'Vous êtes à jour')}
      </p>
    </div>
  );
};

export default NetBalanceHeader;
